/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import type {
  Client,
  RequestConfig,
  ResponseErrorConfig,
} from '../../../apiClient'
import type {
  GetCampaignInsightsQueryResponse,
  GetCampaignInsightsPathParams,
  GetCampaignInsightsQueryParams,
  GetCampaignInsights404,
} from '../../types/GetCampaignInsights'
import type {
  QueryKey,
  QueryClient,
  QueryObserverOptions,
  UseQueryResult,
} from '@tanstack/react-query'
import { getCampaignInsights } from '../../clients/getCampaignInsights'
import { queryOptions, useQuery } from '@tanstack/react-query'

export const getCampaignInsightsQueryKey = (
  {
    campaign_id,
  }: { campaign_id: GetCampaignInsightsPathParams['campaign_id'] },
  params?: GetCampaignInsightsQueryParams
) =>
  [
    {
      url: '/api/v1/emailbison/campaigns/:campaign_id/insights/',
      params: { campaign_id: campaign_id },
    },
    ...(params ? [params] : []),
  ] as const

export type GetCampaignInsightsQueryKey = ReturnType<
  typeof getCampaignInsightsQueryKey
>

export function getCampaignInsightsQueryOptions(
  {
    campaign_id,
  }: { campaign_id: GetCampaignInsightsPathParams['campaign_id'] },
  params?: GetCampaignInsightsQueryParams,
  config: Partial<RequestConfig> & { client?: Client } = {}
) {
  const queryKey = getCampaignInsightsQueryKey({ campaign_id }, params)
  return queryOptions<
    GetCampaignInsightsQueryResponse,
    ResponseErrorConfig<GetCampaignInsights404>,
    GetCampaignInsightsQueryResponse,
    typeof queryKey
  >({
    enabled: !!campaign_id,
    queryKey,
    queryFn: async ({ signal }) => {
      return getCampaignInsights({ campaign_id: campaign_id }, params, {
        ...config,
        signal: config.signal ?? signal,
      })
    },
  })
}

/**
 * @description Return fresh EmailBison stats and chart data for a local campaign.
 * Endpoint:
 * - GET /api/emailbison/campaigns/<campaign_id>/insights/
 * @summary Get campaign insights
 * {@link /api/v1/emailbison/campaigns/:campaign_id/insights/}
 */
export function useGetCampaignInsights<
  TData = GetCampaignInsightsQueryResponse,
  TQueryData = GetCampaignInsightsQueryResponse,
  TQueryKey extends QueryKey = GetCampaignInsightsQueryKey,
>(
  {
    campaign_id,
  }: { campaign_id: GetCampaignInsightsPathParams['campaign_id'] },
  params?: GetCampaignInsightsQueryParams,
  options: {
    query?: Partial<
      QueryObserverOptions<
        GetCampaignInsightsQueryResponse,
        ResponseErrorConfig<GetCampaignInsights404>,
        TData,
        TQueryData,
        TQueryKey
      >
    > & { client?: QueryClient }
    client?: Partial<RequestConfig> & { client?: Client }
  } = {}
) {
  const { query: queryConfig = {}, client: config = {} } = options ?? {}
  const { client: queryClient, ...resolvedOptions } = queryConfig
  const queryKey =
    resolvedOptions?.queryKey ??
    getCampaignInsightsQueryKey({ campaign_id }, params)

  const query = useQuery(
    {
      ...getCampaignInsightsQueryOptions({ campaign_id }, params, config),
      ...resolvedOptions,
      queryKey,
    } as unknown as QueryObserverOptions,
    queryClient
  ) as UseQueryResult<TData, ResponseErrorConfig<GetCampaignInsights404>> & {
    queryKey: TQueryKey
  }

  query.queryKey = queryKey as TQueryKey

  return query
}
